<template>
  <div class="d-flex justify-content-center mt-md-3 pointer">
    <nav aria-label="Page navigation ">
      <ul class="pagination">
        <li class="page-item">
          <button
            :disabled="!pagination.prev_page_url"
            class="page-link"
            href="#"
            aria-label="Previous"
            @click="changePage(requestParams.page - 1)"
          >
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </button>
        </li>
        <li
          class="page-item"
          v-for="page in pages"
          :key="page.id"
          :class="{ active: isPageActive(page.name) }"
        >
          <button
            type="button"
            @click="changePage(page.name)"
            class="page-link"
            :aria-label="`Go to page number ${page.name}`"
          >{{ page.name }}</button>
        </li>
        <li class="page-item" :disabled="!requestParams.next_page_url">
          <button
            :disabled="!pagination.next_page_url"
            class="page-link"
            aria-label="Next"
            @click="changePage(requestParams.page + 1)"
          >
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    },
    requestParams: {
      type: Object,
      required: true
    },
    onChangedPage: {
      type: Function,
      required: true
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  methods: {
    changePage (page) {
      if (page < 1) page = 1
      this.requestParams.page = page
      this.onChangedPage()
    },
    isPageActive (page) {
      return this.requestParams.page === page
    }
  },
  computed: {
    startPage () {
      if (this.requestParams.page === 1) {
        return 1
      }

      if (this.requestParams.page === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons + 1
      }

      return this.requestParams.page - 1
    },
    endPage () {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, Math.ceil(this.pagination.total / this.pagination.to))
    },
    pages () {
      const range = []

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.requestParams.page
        })
      }

      return range
    }
  }

}
</script>
<style lang="scss" scoped>
.page-item .page-link {
  border: none;
  background: none;
}
.page-link {
  color: $gray-500;
}
.page-item.active .page-link {
  color: $gray-600;
}
</style>
